var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "logo_svg__Layer_1",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 566.93 566.93"
    },
    viewBox: "0 0 566.93 566.93"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".logo_svg__st0{opacity:.72;fill:#5c3df5}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M335.01 240.71c-4.12 31.16-2.28 63.49 7.06 103.68 2.15 9.25-4.8 18.1-13.76 17.45-34.58-2.53-66.07-12.56-91.26-27.77-4.05 30.6-13.85 60.07-27.98 94.76-4.9 12.02 4.12 25.24 16.41 24.06 82.93-8 169.52-58.56 169.52-119.74 0-37.09-23.3-70.27-59.99-92.44zM229.99 230.38c-2.15-9.25 4.8-18.1 13.76-17.45 34.58 2.53 66.07 12.56 91.26 27.77 4.05-30.6 13.85-60.07 27.98-94.76 4.9-12.02-4.12-25.24-16.41-24.06-82.93 8-169.52 58.56-169.52 119.74 0 37.09 23.3 70.27 59.99 92.44 4.13-31.15 2.29-63.48-7.06-103.68z",
    className: "logo_svg__st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M342.07 344.39c-9.34-40.19-11.19-72.52-7.06-103.68-25.18-15.22-56.67-25.25-91.26-27.77-8.96-.66-15.91 8.2-13.76 17.45 9.34 40.19 11.19 72.52 7.06 103.68 25.18 15.22 56.67 25.25 91.26 27.77 8.96.66 15.91-8.2 13.76-17.45z",
    className: "logo_svg__st0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M342.07 344.39c-9.34-40.19-11.19-72.52-7.06-103.68-25.18-15.22-56.67-25.25-91.26-27.77-8.96-.66-15.91 8.2-13.76 17.45 9.34 40.19 11.19 72.52 7.06 103.68 25.18 15.22 56.67 25.25 91.26 27.77 8.96.66 15.91-8.2 13.76-17.45z",
    style: {
      fill: "#5c3df5"
    }
  }));
};
export default SvgLogo;